export function ModalDefinirEnderecoDevolucaoController ($uibModalInstance) {
  'ngInject';

  var modalDefinirDevolucao = this;

  modalDefinirDevolucao.back = function () {
    $uibModalInstance.dismiss('cancel');
  };

  modalDefinirDevolucao.confirm = function () {
    $uibModalInstance.close();
  };
}
